import { HelmetProvider } from "react-helmet-async";
import DashBoard2 from "./component/Dashboard/DashBoard2";
import MyBeShowNavbar from "./component/MyBeShowNavbar/MyBeShowNavbar";
import React from "react";

function App() {
  return (
    <HelmetProvider>
      <MyBeShowNavbar>
        <DashBoard2 />
      </MyBeShowNavbar>
    </HelmetProvider>
  );
}

export default App;
